const GOOGLE_ADS_STARTED_FREE_TRIAL_CONVERSION =
  'AW-11198534691/oPPyCN7S0aoYEKOo8Nsp';

const STRIPE_INTENT_ID = /^(seti|pi)_[A-Za-z0-9]+$/;

export function googleAdsStartTrialScript(
  currency: string,
  stripeIntentId: string | null,
) {
  const transactionId =
    stripeIntentId && STRIPE_INTENT_ID.test(stripeIntentId)
      ? stripeIntentId
      : '';
  return `
/* eslint-disable -- inline pixel script, vendor-shaped js */
window.dataLayer = window.dataLayer || [];
function gtag() { dataLayer.push(arguments); }
gtag('event', 'conversion', {
  send_to: '${GOOGLE_ADS_STARTED_FREE_TRIAL_CONVERSION}',
  value: 0,
  currency: '${currency}',
  transaction_id: '${transactionId}',
});
`;
}
